import React, { useEffect, useState } from "react";
import UserLayout from "../../components/layout/UserLayout";
import { useNavigate } from "react-router-dom";
import { useUploadAvatarMutation } from "../../redux/api/userApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {Image} from 'react-bootstrap';
const UploadAvatar = () => {
  const { user } = useSelector((state) => state.auth);

  const [avatar, setAvatar] = useState("");
  const [avatarPreview, setAvatarPreview] = useState(
    user?.avatar ? user?.avatar?.url : "/img/default_avatar.jpg"
  );

  const navigate = useNavigate();

  const [uploadAvatar, { isLoading, error, isSuccess }] = useUploadAvatarMutation();

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message);
    }

    if (isSuccess) {
      toast.success("Avatar Uploaded");
      navigate("/me/profile");
    }
  }, [error, isSuccess, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();

    const userData = {
      avatar,
    };

    uploadAvatar(userData);
  };

  const onChange = (e) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setAvatarPreview(reader.result);
        setAvatar(reader.result);
      }
    };

    reader.readAsDataURL(e.target.files[0]);
  };

  return (
    <UserLayout>
      <div className="flex flex-wrap justify-center">
        <div className="w-10/12 lg:w-8/12">
          <form
            className="shadow-lg rounded bg-white p-5"
            onSubmit={submitHandler}
          >
            <h2 className="text-2xl mb-4">Upload Avatar</h2>

            <div className="mb-3">
              <div className="flex items-center">
                <div className="mr-3">
                  <figure className="w-24 h-24">
                    <Image
                      src={avatarPreview}
                      className="rounded-full"
                      alt="Avatar preview"
                    />
                  </figure>
                </div>
                <div className="">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="customFile"
                  >
                    Choose Avatar
                  </label>
                  <input
                    type="file"
                    name="avatar"
                    className="block w-full text-sm text-gray-500
                              file:mr-4 file:py-2 file:px-4
                              file:rounded-full file:border-0
                              file:text-sm file:font-semibold
                              file:bg-violet-50 file:text-violet-700
                              hover:file:bg-violet-100"
                    id="customFile"
                    accept="image/*" // Corrected to properly accept images
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>

            <button
              id="register_button"
              type="submit"
              className={`w-full py-2 rounded ${
                isLoading ? "bg-gray-300" : "bg-blue-500 text-white"
              } transition-colors duration-150`}
              disabled={isLoading}
            >
              {isLoading ? (
                <i className="fas fa-spinner fa-spin"></i>
              ) : (
                "Upload"
              )}
            </button>
          </form>
        </div>
      </div>
    </UserLayout>
  );
};

export default UploadAvatar;
